export default __webpack_public_path__ + "static/media/phone.213d6754.png";